import Vue from 'vue'
import router from './router'
import App from './App.vue'
import axios from 'axios'
import Mint from 'mint-ui'
import config from './config'
import init from '@ivy/fts'
import store from './store'
import { closeAll } from "@ivy/fts/showDiv"
Vue.component('TopBar', () => import("@ivy/fts/inner/topBarOpenApp.vue"))
Vue.component('IvyHeader', () => import("./components/header.vue"))
Vue.component('IvyFooter', () => import("./components/floatBar.vue"))
Vue.component('loading', () => import("./components/loading.vue"))
Vue.component('listItem4more', () => import("./pages/_comps/listItem4more.vue"))
Vue.component('VipFooter', () => import("./components/vipFooter.vue"))
Vue.component('Own', () => import("./components/own.vue"))
Vue.use(Mint.Popup)
let InfiniteScroll = Mint.InfiniteScroll
Vue.use(InfiniteScroll)
init({ Vue, router, axios, config, Mint })
Vue.prototype.$store = store
Vue.config.productionTip = false
router.beforeEach(async (to, from, next) => {
  if (to.meta && to.meta.title) {
    Vue.prototype.$title(to.meta.title)
  } else if (!document.title) {
    Vue.prototype.$title('常青藤爸爸')
  }
  next()
})
router.afterEach((to, from) => {
  window.scrollTo(0, 0)
  closeAll()
})
new Vue({
  router,
  render: h => h(App)
}).$mount('#app-box')
